import React from "react";
import Routes from "./Routes/index";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// Import Scss
import './assets/scss/theme.scss';
import './assets/style/style.css'
// import "./assets/scss/custom/plugins/_toastr.scss";
// import 'react-toastify/dist/ReactToastify.css';
// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();




function App() {
  console.log = function () { };
  console.debug = function () { };
  console.error = function () { };
  console.warn = function () { };
  return (
    <React.Fragment>
      <Routes />
      <ToastContainer />
    </React.Fragment>
  );
}

export default App;
